export const openLocateStoreMenu = () => window.dispatchEvent(new CustomEvent('open-locate-store'));

export const onLocateStoreOpen = (callback: () => void) => {
	window.addEventListener('open-locate-store', callback);
	return () => window.removeEventListener('open-locate-store', callback);
};
